// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/navigation/AccordionNav.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/navigation/AccordionNav.tsx");
  import.meta.hot.lastModified = "1721938849118.152";
}
// REMIX HMR END

import { Disclosure } from "@headlessui/react";
import clsx from "clsx";
import { Fragment } from "react";
import Link from "~/components/Link";
import IconResolver from "~/components/IconResolver";
export default function AccordionNav({
  title,
  items,
  closeNav
}) {
  return <Disclosure>
      {({
      open
    }) => <Fragment>
          <Disclosure.Button as="div" className={clsx("flex justify-start items-center hover:text-secondary-500 w-full px-4 py-5", open ? "text-secondary-500" : "text-neutral-100")}>
            {title}
            <IconResolver token="chevron-down" className={clsx("w-4.5 h-4.5 ml-1 transition-transform duration-200", open && "transform rotate-180")} />
          </Disclosure.Button>
          <Disclosure.Panel className="bg-primary-900">
            <ul className="border-t border-primary-500 divide-y divide-primary-500">
              {items?.map(({
            title,
            url
          }) => <li key={title} onClick={closeNav}>
                  <Link prefetch="intent" to={url} className="block w-full px-4 py-5" theme="dark">
                    {title}
                  </Link>
                </li>)}
            </ul>
          </Disclosure.Panel>
        </Fragment>}
    </Disclosure>;
}
_c = AccordionNav;
var _c;
$RefreshReg$(_c, "AccordionNav");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;